import type { ReactNode } from 'react';
import cn from 'classnames';

import useMedia from 'hooks/useMedia';
import type { WithTestId } from 'types/app';

import { AnalyticsTypes } from '@Modules/analytics/types';

import { Location } from '@Atomic/organisms/Location';
import { SortingDropdown } from '@Atomic/organisms/Sorting/SortingDropdown';

import styles from './filtersToolsPanel.module.scss';

type FiltersToolsPanelProps = WithTestId<{
  className?: string;
}>;

export const FiltersToolsPanel = ({
  testId = 'filters-tools-panel',
  className,
}: FiltersToolsPanelProps): ReactNode => {
  const { xs, sm } = useMedia();
  const isMobile = xs || sm;

  // Mobile web keeps geo in the header and sorting in the filters chips row (SortChip)
  if (isMobile) {
    return null;
  }

  return (
    <div className={cn(styles.container, className)} data-testid={testId}>
      <Location
        button={{ size: 'extra-small' }}
        analyticsSource={AnalyticsTypes.RegionSelectorSource.FILTERS}
      />
      <SortingDropdown />
    </div>
  );
};
